<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{title}}
</h1>
<div mat-dialog-content>
    <div>
        <mat-form-field appearance="outline" class="input">
            <mat-label>Role Name</mat-label>
            <input matInput [(ngModel)]="role.name" placeholder="{{role.name}}" name="roleName" autocomplete="off" required />
        </mat-form-field>
    </div>
    <div>
        <mat-checkbox [(ngModel)]="role.isSiteLevel" name="isSiteLevel" [disabled]="role.isSiteAdmin">Site-Level Role</mat-checkbox>
    </div>
    <span class="warning" *ngIf="GetShowWarning()">Making this folder-level role site-wide will remove all members from this role at the folder level and add them at the site level.</span>
    <br />
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" class="theme-primary-btn" [mat-dialog-close]="this.role" [disabled]="DisableSave()">Save</button>
    <button *ngIf="ShowCancel()" mat-flat-button type="button" [mat-dialog-close]="null">Cancel</button>
    <button *ngIf="!ShowCancel()" mat-flat-button type="button" (click)="reset()">Reset</button>
</div>
